import {createCrudSlice} from "../genericCrudSlice";
import {getMovementApi} from "../../api/entities/movements";


const movementsCrudSlice = createCrudSlice('movements', 'Edit Movement', 'New Movement', getMovementApi);
export const {openModalForEdit} = movementsCrudSlice;
export const {reset, openModalForCreate, closeModal, setItem} = movementsCrudSlice.actions;
export default movementsCrudSlice.reducer;